module.exports = __webpack_public_path__ + "static/media/Artboard20.5d1ee385.png";